module.exports = __webpack_public_path__ + "img/about.e15ddb49.png";